/**
 * The device id. localStorage is acceptable here and nowhere else: it is a single
 * immutable string written once, not mutable state. Section 6.3 permits exactly this.
 * If localStorage is ever cleared we mint a new id; nothing depends on it being
 * stable beyond conflict tie-breaks, and the database itself keeps a copy in `meta`.
 */
const LS_KEY = 'fl73.deviceId';

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(LS_KEY);
    if (existing) return existing;
    const fresh = mint();
    localStorage.setItem(LS_KEY, fresh);
    return fresh;
  } catch {
    return mint();   // private browsing, storage disabled: still works, just not stable
  }
}

function mint(): string {
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  return 'dev-' + [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}
